import React from 'react'
import { useModal } from '../../hooks/modal'
import { useDeleteRequest } from '../../hooks/request'
import { CUSTOMER_DETAIL } from '../../urls'
import Button from '../../components/common/Button'
import CustomerUpdate from './CustomerUpdate'

export default function CustomerItem({ customer, expense, item, index }) {
    const productRemove = useDeleteRequest({ url: CUSTOMER_DETAIL.replace('{id}', item.id) })

    async function onDelete() {
        if (global.confirm('Вы действительно хотите удалить?')) {
            await productRemove.request()
            expense.request()
        }
    }

    const [showUpdateModal, hideUpdateModal] = useModal(
        <CustomerUpdate
            clients={customer}
            item={item}
            onCancel={() => {
                expense.request()
                hideUpdateModal()
            }}
        />,
    )

    return (
        <tr className=" is-size-6" key={item.id}>
            <td className="is-size-6">{index + 1}</td>
            <td className="is-size-6">{item.fullName}</td>
            <td className="is-size-6">{(item.phoneNumber)}</td>
            <td>
                <div style={{ display: 'flex' }} className="has-text-right">
                    <Button onClick={showUpdateModal} className="mr-2 button is-success is-outlined is-small"
                        icon="pencil-outline" />
                    <Button onClick={onDelete} className="button is-danger mr-2 is-outlined is-small" icon="trash" />
                </div>
            </td>
        </tr>

    )
}
